/*!
 * @license
 * Alfresco Example Content Application
 *
 * Copyright (C) 2005 - 2019 Alfresco Software Limited
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail.  Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with Alfresco. If not, see <http://www.gnu.org/licenses/>.
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

import { PageLayoutComponent } from '@alfresco/aca-shared';
import { MatTableModule } from '@angular/material/table';

export interface GuideData {
  name: string;
  description: string;
  url: string;
}

@Component({
  standalone: true,
  imports: [PageLayoutComponent, MatTableModule],
  selector: 'app-user-guide-list',
  templateUrl: './user-guide-list.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserGuideListComponent {
  columns = [
    {
      columnDef: 'name',
      header: 'Name',
      cell: (row: GuideData) => `${row.name}`
    },
    {
      columnDef: 'description',
      header: 'Description',
      cell: (row: GuideData) => `${row.description}`
    },
    {
      columnDef: 'url',
      header: 'Url',
      cell: (row: GuideData) => `${row.url}`
    }
  ];

  displayedColumns = this.columns.map((x) => x.columnDef);

  @Input()
  data: Array<GuideData> = [];
}
